import React, {useEffect, useRef} from 'react';
import IconClose from './CloseIcon'
import IconCheck from '../../images/check_icon.svg';
import './Modal.sass';
import ShopBtn from "../ShopBtn/ShopBtn";
import QrCode from "../QrCode/QrCode";
import classNames from 'classnames';
import { ANDROID_APP_LINK, IOS_APP_LINK, RUSTORE_APP_LINK, APPGALLERY_APP_LINK } from '../../constants';

import IconGooglePlayRu from '../../images/google_play_badge_ru_color_40.svg';
import IconGooglePlayEn from '../../images/google_play_badge_en_color_40.svg';
import IconRuStoreRu from '../../images/rustore_badge_ru_color_40.svg';
import IconRuStoreEn from '../../images/rustore_badge_en_color_40.svg';
import IconAppleRu from '../../images/app_store_badge_ru_color_40.svg';
import IconAppleEn from '../../images/app_store_badge_en_color_40.svg';
import IconAppGalleryRu from '../../images/app_gallery_badge_ru_color_40.svg';
import IconAppGalleryEn from '../../images/app_gallery_badge_en_color_40.svg';

import data from '../../data';

const Modal = ({
   qrCodeText,
   isOpen,
   handleSetOpen,
   phoneNumber,
   isHuaweiAppGallery,
}) => {
    const overlayModal = useRef(null);
    const handleOutsideClick = (e) => {
        if (e.target.isEqualNode(document.querySelector('.modal__overlay'))) {
            handleSetOpen(false)
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        }
    }, []);

    useEffect(() => {
        if(overlayModal && overlayModal.current) {
            overlayModal.current.addEventListener('wheel', e => e.stopPropagation() )
        }
    }, [overlayModal.current]);

    return (
        <div className={classNames({
            modal: true,
            'modal--open': isOpen
        })}>
            <div className="modal__overlay" ref={overlayModal}>
                <div className="modal__container">

                    <div
                        className="modal__close"
                        onClick={_ => handleSetOpen(false)}
                    >
                        <IconClose/>
                    </div>

                    <div className="modal__icon">
                        <img src={IconCheck} alt="отправлено"/>
                    </div>

                    <h6 className="modal__title">Ссылка отправлена</h6>

                    <p className="modal__decription">
                        Ссылка отправлена сообщением на номер
                        &nbsp;
                        <span dangerouslySetInnerHTML={{__html: `${phoneNumber}`}}></span>
                        . Если вы не получили сообщение — воспользуйтесь любым другим способом ниже, чтобы скачать
                        приложение.
                    </p>

                    <div className="modal__actions">
                        <div className="modal__action">
                            <ShopBtn
                                href={IOS_APP_LINK}
                                icon={data.isEng ? IconAppleEn : IconAppleRu}
                                type={"apple"}
                            />
                        </div>
                        {isHuaweiAppGallery ? (
                            <div className="modal__action">
                                <ShopBtn
                                    href={APPGALLERY_APP_LINK}
                                    icon={data.isEng ? IconAppGalleryEn : IconAppGalleryRu}
                                    type="huawei"
                                />
                            </div>
                        ) : (
                            <>
                                {data.isGooglePlayAvailable ? <div className="modal__action">
                                    <ShopBtn
                                        href={ANDROID_APP_LINK}
                                        icon={data.isEng ? IconGooglePlayEn : IconGooglePlayRu}
                                        type={"google"}
                                    />
                                </div> : ''}
                                <div className="modal__action">
                                    <ShopBtn
                                    href={RUSTORE_APP_LINK}
                                    icon={data.isEng ? IconRuStoreEn : IconRuStoreRu}
                                    type={"rustore"}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <QrCode
                        text={qrCodeText}
                        type={"modal"}
                    />
                </div>
            </div>
        </div>
    );
};

export default Modal;
